import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function WhyKryzenBiotech() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Why Kryzen Biotech? | Hydroponic Farm Development Experts"
        description="Kryzen Biotech specializes in commercial hydroponic farm development — from planning to construction and lifetime support. Known for custom nutrient solutions and advanced farming technology."
        keywords="Kryzen Biotech, hydroponic farm developers, commercial hydroponics India, hydroponic nutrient solutions, turnkey farming solutions, hydroponic technology company, hydroponic system provider"
        canonical="https://alpha.kryzen.com/why-kryzen-biotech"
        ogTitle="Why Kryzen Biotech? | Hydroponic Farm Development Experts"
        ogDescription="Kryzen Biotech delivers end-to-end hydroponic farming solutions with custom nutrients, high-tech systems, and full lifecycle support — trusted by commercial growers across India."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302205/7-1_ammu0p.jpg"
        twitterTitle="Why Kryzen Biotech? | Hydroponic Farm Development Experts"
        twitterDescription="Kryzen Biotech is your partner in hydroponic farming success — offering tailored nutrient solutions, advanced technologies, and unmatched support for commercial farms."
      />
      <div>
        <Slider
          heding={"Why Kryzen Biotech ?"}
          paragraph={
            "Kryzen Biotech is a company specializing in hydroponic farm development, offering services from initial planning to construction and ongoing support. They focus on creating profitable, sustainable hydroponic farms, particularly for commercial applications."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              Why Kryzen Biotech ?
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Kryzen Biotech is a company specializing in hydroponic farm
              development, offering services from initial planning to
              construction and ongoing support. They focus on creating
              profitable, sustainable hydroponic farms, particularly for
              commercial applications. They stand out due to their expertise in
              developing customized nutrient solutions, utilizing advanced
              technologies, and providing comprehensive support throughout the
              farm's lifecycle.
            </motion.p>
          </div>
          <div className="row g-5 align-items-stretch mt-5">
            {/* Left Column */}
            <div className="col-md-12">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                // variants={fadeUp}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  //   variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302205/7-1_ammu0p.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  //   style={{ width: "100%", height: "300px" }}
                />
                {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Main Frame Material
                  </h5>
                  <motion.p
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    Constructed from high-quality hot-dip galvanized steel, our
                    structure boasts a Zinc-coating of 275g/m2, ensuring a
                    robust service life of over 20 years. The steel components
                    are assembled on-site without needing secondary processing.
                    Galvanized connectors and fasteners are designed to resist
                    rust for two decades, guaranteeing long-term durability and
                    reliability.
                  </motion.p>
                </div> */}
              </motion.div>
            </div>
          </div>
          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase  mb-2"
            >
              We setup Industry standard, profit driven hydroponic farms.
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              We are top turnkey commercial hydroponics farm project development
              company. We set up hydroponic farms that are low in capex and high
              in returns on investment. With fastest ROI mechanism, We develop
              farm that generates good returns in lowest possible time.
            </motion.p>
          </div>
          <div
            className=" py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
              color: "black",
              border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
              padding: "1rem",
              borderRadius: "0.25rem",
            }}
          >
            <div className="row">
              <div className="col-md-4 mb-2 d-flex justify-content-center">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302412/8401_KRYZEN-BIOTECH-PRIVATE-LIMITED_HACCP-1-min_dr8gie.png"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>
              <div className="col-md-4 mb-2 d-flex justify-content-center">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302411/8401_KRYZEN-BIOTECH-PRIVATE-LIMITED_GMP-1-min_h5jqee.png"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>
              <div className="col-md-4 mb-2 d-flex justify-content-center">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302411/8401_KRYZEN-BIOTECH-PRIVATE-LIMITED_14001-1-min_gszmta.png"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>

              <div className="col-md-4 mb-2 d-flex justify-content-center mt-4">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302410/8401_KRYZEN-BIOTECH-PRIVATE-LIMITED_22000-1-min_qxswan.png"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>

              <div className="col-md-4 mb-2 d-flex justify-content-center mt-4">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302437/fssai_uysp0o.jpg"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>

              <div className="col-md-4 mb-2 d-flex justify-content-center mt-4">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752302409/1661_KRYZEN_9001-1-min_r1bcbu.png"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "300px", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HEAT TRAPPING CARBONATE
                  </h5>
                </div> */}
                </div>
              </div>
            </div>
          </div>
          <h1 className="display-6 fw-bold text-uppercase text-center mb-2 mt-7">
            Our Core Values That Make Us #1 Hydroponics Company of India
          </h1>
          <hr></hr>{" "}
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Quality Services
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    We at Kryzen Biotech always put quality first. Our farms are
                    equipped with top of the line technology, so you can grow
                    your plants in a safe environment that will not only look
                    great but also produce high yields!
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Planning & Strategy
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    All systems are designed and customized to specific needs.
                    The team takes into consideration what’s being grown, as
                    well as other factors such as light quality or water
                    availability before designing an effective system.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-3">
              <div
                className=" border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Clients Satisfaction
                  </h5>
                  <p style={{ fontSize: "18px" }}>
                    We are India’s #1 top hydroponic farming delivering
                    hydroponic projects of all sizes and any location and that
                    has helped us gain trust from all of our clients. We always
                    put client and project requirements on top priority
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div
                className="border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
                style={{
                  background:
                    "color-mix(in srgb,rgb(187, 187, 187) 10%, transparent)",
                  color: "black",
                  border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
                  padding: "1rem",
                  borderRadius: "0.25rem",
                }}
              >
                <div className="card-body p-4 text-center">
                  <h3 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Independent Staff
                  </h3>
                  <p style={{ fontSize: "18px" }}>
                    Kryzen Biotech has a dedicated team of professionals who
                    work to make sure that our customer’s projects are executed
                    flawlessly. Our team of experts from various fields are
                    chosen after the regressive interview process.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752303313/2-5_msmc8e.png"
                  alt="Who We Are?"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "250px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Who We Are?
                  </h5>
                  <p>
                    Kryzen Biotech is Controlled Environment Agriculture (CEA)
                    specialist company that combines sustainable technology and
                    modern farming techniques, to create highly productive
                    models for the new-age urban farmer.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752303313/3-3_xxbtxe.png"
                  alt="Our Mission"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "250px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Our Mission{" "}
                  </h5>
                  <p>
                    Kryzen Biotech is working on a Big Mission to empower 1 lakh
                    urban farmers in field of hydroponics & soil-less farming
                    with help of advance technology, Artificial Intelligence and
                    Machine Learning.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752303313/1-5_fqefm8.png"
                  alt="Our Vision"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "250px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Our Vision
                  </h5>
                  <p>
                    We aim to make agriculture a sustainable business by 2030
                    for rural as well as urban farmers. Our efforts are directed
                    towards promoting avoiding food wastage and increasing
                    return value on investment.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <h1 className="display-6 fw-bold text-uppercase text-center mb-2 mt-7">
            Here's a more detailed look at why Kryzen Biotech is a strong choice
            for hydroponic farming
          </h1>
          <hr></hr>{" "}
          <div className="row g-5 align-items-stretch mt-2">
            {/* Left Column */}
            <div className="col-md-6">
              <div
                className="border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Expertise and Experience
                  </h5>
                  <hr></hr>
                  <p>
                    <b>Hydroponic Farm Development:</b>Kryzen Biotech has
                    extensive experience in developing and implementing
                    hydroponic farms of various scales, from small setups to
                    large commercial operations.
                  </p>
                  <p>
                    <b>Customized Solutions:</b>They develop tailored nutrient
                    solutions based on the specific needs of the crops being
                    grown and the farm's environment, ensuring optimal growth
                    and yield.
                  </p>
                  <p>
                    <b>Turnkey Solutions:</b>Kryzen Biotech offers comprehensive
                    services, including initial planning, site selection,
                    construction, and ongoing support, allowing clients to focus
                    on their core operations.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Technology and Innovation
                  </h5>
                  <hr></hr>
                  <p>
                    <b>Advanced Monitoring Systems:</b>They incorporate
                    cutting-edge technology, including advanced monitoring
                    systems and automation, to optimize farm performance and
                    resource management.
                  </p>
                  <p>
                    <b>Data-Driven Approach:</b>Kryzen Biotech leverages
                    scientific research and data analysis to develop their
                    nutrient solutions and improve farming practices.
                  </p>
                  <p>
                    <b>Sustainable Practices:</b>Their focus on sustainability
                    includes water conservation, efficient resource utilization,
                    and minimizing environmental impact.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Focus on Profitability and Client Success
                  </h5>
                  <hr></hr>
                  <p>
                    <b>High ROI:</b>Kryzen Biotech designs hydroponic farms with
                    a focus on maximizing return on investment, aiming for rapid
                    and high returns.
                  </p>
                  <p>
                    <b>Client Satisfaction:</b>They prioritize client needs and
                    project requirements, ensuring that their farms are designed
                    and implemented to meet specific goals.
                  </p>
                  <p>
                    <b>Wide Range of Solutions:</b>Kryzen Biotech caters to a
                    diverse clientele, including individuals, corporations, and
                    institutions.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div
                className="border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <div className="card-body p-4">
                  <h5 className="card-title fs-2 fw-semibold mb-3 text-primary">
                    Specific Advantages for Hydroponics
                  </h5>
                  <hr></hr>
                  <p>
                    <b>Reduced Space and Water Consumption:</b>Hydroponics
                    allows for efficient use of space and water compared to
                    traditional agriculture, making it ideal for urban areas and
                    regions with limited resources.
                  </p>
                  <p>
                    <b>Year-Round Production:</b>Hydroponic farms can operate
                    year-round, regardless of external weather conditions,
                    ensuring consistent supply of fresh produce.
                  </p>
                  <p>
                    <b>Increased Yield and Quality:</b>Hydroponic systems can
                    produce higher yields with superior quality compared to
                    traditional farming methods.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default WhyKryzenBiotech;
